export default __webpack_public_path__ + "static/media/failed-icon.5a98acbe.svg";